import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import CustomQuerySetupSheetLoaderComponent from 'webapp/components/custom-query/setup/sheet/loader';
import CustomQuerySetupWizardSheetControlsComponent from 'webapp/components/custom-query/setup/wizard/sheet/controls';
import CustomQuerySetupWizardSheetPreviewComponent from 'webapp/components/custom-query/setup/wizard/sheet/preview';
import type { Args } from 'webapp/components/custom-query/setup/wizard/sheet/step-common';
import ToolTipComponent from 'webapp/components/tool-tip';

interface CustomQuerySetupWizardSheetStepVerifyComponentInterface {
	Args: Args;
	Blocks: { default: [] }; // this is needed for yield
}

// prettier-ignore
export default class CustomQuerySetupWizardSheetStepVerifyComponent extends Component<CustomQuerySetupWizardSheetStepVerifyComponentInterface> {
	get showTooltip(): boolean {
		const source = this.args.model.sourceObj;
		return !!source && source.title.length >= 30;
	}

	get showSheetActions() {
		const source = this.args.model.sourceObj;
		return !source?.sourceType?.isFileUpload;
	}

	@action
	reloadSheetData(): void {
		const form = this.args.form;
		if (!form.isSheetDataReloading) {
			form.reloadData();
		}
	}
	<template>
		<div class="step-ct">
			<div class="top">
				<h3>Please verify your data</h3>
				<div class="source-info">
					<img
						class="avatar"
						src={{@model.sourceObj.realAvatar}}
						alt={{@model.sourceObj.sourceType.name}}
					/>
					<div>
						<div class="t">{{@model.sourceObj.title}}</div>
						{{#if this.showTooltip}}
							<ToolTipComponent @text={{@model.sourceObj.title}} />
						{{/if}}
					</div>

					{{#if this.showSheetActions}}
						{{#if @form.fileUrl}}
							<a class="o" href={{@form.fileUrl}} target="_blank">
								Original document
								<CommonUiIconComponent @name="External" @size="xs" />
							</a>
						{{/if}}
						<a class="r" {{on "click" this.reloadSheetData}}>
							<CommonUiIconComponent @name="Refresh" @size="sm" />
							Refresh sheet data
						</a>
					{{/if}}
				</div>

				{{yield}} {{!-- .toggle-manual button --}}
			</div>

			<div class="table">
				{{#if @form.isSheetDataReloading}}
					<CustomQuerySetupSheetLoaderComponent />
				{{else}}
					<CustomQuerySetupWizardSheetPreviewComponent @model={{@form}} />
				{{/if}}
			</div>
		</div>

		{{!-- controlsNode could still be unrendered --}}
		{{#if @controlsNode}}
			{{#in-element @controlsNode}}
				<CustomQuerySetupWizardSheetControlsComponent
					@showBack={{false}}
					@isButtonDisabled={{false}}
					@submitInProgress={{false}}
					@goNext={{@goNext}}
					@goPrevious={{@goPrevious}}
				/>
			{{/in-element}}
		{{/if}}
	</template>
}
